var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.containsCode
    ? _c("div", { staticClass: "grouped-entity-card-wrapper" }, [
        _c("div", { staticClass: "card-title-wrapper" }, [
          _c("img", {
            staticStyle: {
              height: "40px",
              width: "40px",
              "margin-right": "10px"
            },
            attrs: { src: _vm.getIconURL }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "grouped-card-title",
              on: {
                click: function($event) {
                  return _vm.$emit("titleClick")
                }
              }
            },
            [_vm._v(_vm._s(_vm.cardTitle))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "see-all-btn",
              on: {
                click: function($event) {
                  return _vm.$emit("titleClick", _vm.cardTitle)
                }
              }
            },
            [_vm._v("See All")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          _vm._l(_vm.getTopEntities, function(item) {
            return _c("div", [
              _vm.getEntityName(item)
                ? _c("div", { staticClass: "list-entity" }, [
                    _c(
                      "div",
                      {
                        staticClass: "entity-name",
                        on: {
                          click: function($event) {
                            return _vm.$emit("entityTitleClicked", item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getEntityName(item)) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "grouped-entity-date" }, [
                      _vm._v(_vm._s(_vm.formatDate(item)))
                    ])
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }